import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import {
  Box,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from "@mui/material";
import { FC } from "react";
import {
  CalculationDataInterface,
  FbtVsPayeResults
} from "./FbtVsPayeCalculator";

export const FbtVsPayeTable: FC<{
  calculationData: CalculationDataInterface[];
  results: FbtVsPayeResults[];
}> = ({ calculationData, results }) => {
  const colorGradient = [
    "#E0FCD6",
    "#CBF1BE",
    "#B1E59F",
    "#A5E390",
    "#98E07E",
    "#88D76C"
  ];

  return (
    <>
      {results.length > 0 && (
        <Grid item xs={12} mt={3}>
          <Box
            sx={{
              display: { md: "flex", lg: "none" },
              marginY: 2,
              color: "white !important",
              justifyContent: "flex-end"
            }}
          >
            <Typography>Scroll</Typography>
            <ArrowForwardIcon />
          </Box>
          <TableContainer component={Paper} sx={{ borderRadius: "15px" }}>
            <Table sx={{ backgroundColor: colorGradient[0] }} size="small">
              <TableHead>
                <TableRow>
                  <TableCell
                    sx={{ borderBottom: "1px solid white" }}
                  ></TableCell>
                  {calculationData.map((cd, index) => (
                    <TableCell
                      key={index}
                      colSpan={2}
                      align="center"
                      sx={{
                        fontSize: 20,
                        fontWeight: 700,
                        backgroundColor: colorGradient[index + 1],
                        borderBottom: "1px solid white"
                      }}
                    >
                      {(cd.taxRate * 100).toFixed(2)}% Tax Rate
                    </TableCell>
                  ))}
                </TableRow>

                <TableRow>
                  <TableCell
                    sx={{
                      backgroundColor: colorGradient[0],
                      borderBottom: "1px solid white"
                    }}
                  ></TableCell>{" "}
                  {calculationData.map((_, index) => (
                    <>
                      <TableCell
                        key={`fbt-${index}`}
                        align="center"
                        sx={{
                          fontSize: 15,
                          fontWeight: 700,
                          backgroundColor: colorGradient[index + 1],
                          borderBottom: "1px solid white"
                        }}
                      >
                        FBT
                      </TableCell>
                      <TableCell
                        key={`paye-${index}`}
                        align="center"
                        sx={{
                          fontSize: 15,
                          fontWeight: 700,
                          backgroundColor: colorGradient[index + 1],
                          borderBottom: "1px solid white"
                        }}
                      >
                        PAYE
                      </TableCell>
                    </>
                  ))}
                </TableRow>
              </TableHead>

              <TableBody>
                {[
                  {
                    label: "Taxable benefit/Allowance (Net, GST exempt)",
                    key: "amount",
                    payeKey: "amount"
                  },
                  {
                    label: "Tax rate",
                    key: "fbtTaxRate",
                    payeKey: "taxRate",
                    isTaxRate: true
                  },
                  { label: "Tax", key: "fbtTax", payeKey: "payeTax" },
                  {
                    label: "KiwiSaver (Employer contribution at 3%)",
                    key: "fbtKiwisaver",
                    payeKey: "payeKiwisaver"
                  },
                  {
                    label: "Total tax",
                    key: "fbtTotalTax",
                    payeKey: "payeTotalTax"
                  },
                  {
                    label: "Gross benefit/allowance",
                    key: "fbtGrossBenefit",
                    payeKey: "payeGrossBenefit",
                    bold: true
                  },
                  {
                    label: "Company deduction (taxable value @ 28%)",
                    key: "fbtCompanyDeduction",
                    payeKey: "payeCompanyDeduction",
                    color: "#EA001B"
                  },
                  {
                    label: "Overall cost to the Company",
                    key: "fbtOverallCost",
                    payeKey: "payeOverallCost",
                    bold: true
                  }
                ].map((row) => (
                  <TableRow key={row.label}>
                    <TableCell
                      align="left"
                      sx={{
                        fontSize: "17px",
                        backgroundColor: colorGradient[0],
                        fontWeight: row.bold ? 700 : 500,
                        borderBottom: "1px solid white"
                      }}
                    >
                      {row.label}
                    </TableCell>
                    {results.map((result, index) => (
                      <>
                        <TableCell
                          key={`fbt-${index}`}
                          align="center"
                          sx={{
                            fontSize: "15px",
                            backgroundColor: colorGradient[index + 1],
                            color: row.color ?? "black",
                            fontWeight: row.bold ? 700 : 500,
                            borderBottom: "1px solid white"
                          }}
                        >
                          {row.isTaxRate
                            ? `${(result.fbtTaxRate * 100).toFixed(2)}%`
                            : row.key &&
                              result[row.key as keyof FbtVsPayeResults] !== null
                            ? `$${(
                                result[
                                  row.key as keyof FbtVsPayeResults
                                ] as number
                              )?.toFixed(2)}`
                            : "-"}
                        </TableCell>
                        <TableCell
                          key={`paye-${index}`}
                          align="center"
                          sx={{
                            fontSize: "15px",
                            backgroundColor: colorGradient[index + 1],
                            color: row.color ?? "black",
                            fontWeight: row.bold ? 700 : 500,
                            borderBottom: "1px solid white"
                          }}
                        >
                          {row.isTaxRate
                            ? `${(result.taxRate * 100).toFixed(2)}%`
                            : row.payeKey &&
                              result[row.payeKey as keyof FbtVsPayeResults] !==
                                null
                            ? `$${(
                                result[
                                  row.payeKey as keyof FbtVsPayeResults
                                ] as number
                              )?.toFixed(2)}`
                            : "-"}
                        </TableCell>
                      </>
                    ))}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
      )}
    </>
  );
};
